import { render } from "./ITooltip.vue?vue&type=template&id=5f1f3547"
import script from "./ITooltip.vue?vue&type=script&lang=js"
export * from "./ITooltip.vue?vue&type=script&lang=js"

import "./ITooltip.vue?vue&type=style&index=0&id=5f1f3547&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__